import React from "react";
import "./style/PbgPageThree.scss";

const PbgPageThree = () => {
  return <div className="PbgpageThree_container"></div>;
};

export default PbgPageThree;
